// extracted by mini-css-extract-plugin
export default {"title":"xjEAFRCSDOFZT8HdVvxb","subscriptionNotPaid":"sm0m_q48TkVnzWJrNjgW"};